export default "__VITE_ASSET__6U3vwBsU__"